
export class SupplierOfferMessageModel {

  requestId?: number;

  messageId: number;
  tableName: string;
  message: string;
  messageFromUserId: number;
  messageFromUserFullName: string;
  messageCreatedOn: Date;

  messageFromUserInitials: string;
  activity: string;

  constructor() {
  }
}

export class SupplierOfferMessageSendModel {
  message: string
  supplierOfferId: number;
  messageFromUserId: number;
  messageFromUserFullName: String;
}

